module.exports = __webpack_public_path__ + "static/GitHub_RandomForest-19da9276b9164fd23f91ea21e4b5ca70.png";